import axios from "axios";

const apiCas = axios.create({
  baseURL: "https://backend-cas-contacto.vercel.app/",
});

export default apiCas;
